/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  message, Space, Button, Divider, Upload, Row, Tooltip, Spin,
} from 'antd'
import Cookies from 'js-cookie'
import {
  UploadOutlined,
} from '@ant-design/icons'

import { format } from 'date-fns'

import { fetch, fetchDownload } from '../../utils/fetch'

const FileUpload = ({ orderId, fileType }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [statusCode, setStatusCode] = useState('')

  const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]

  const getFileUrl = async () => {
    if (fileType) {
      setIsLoading(true)
      await fetch({
        url: `/order/${orderId}/header/fileUpload/${fileType}`,
      }).then((res) => {
        if (res?.data?.success) {
          if (res?.data?.data?.length > 0) {
            // console.log(res.data.data)
            setFileList([{
              uid: '1',
              name: res?.data?.data[0]?.fileName,
              status: 'done',
              orderFileId: res?.data?.data[0]?.orderFileId,
            }])
          } else {
            setFileList([])
          }
        } else {
          message.error(res?.data?.message)
        }
      })
      setIsLoading(false)
    }
  }

  const getOrderStatus = () => {
    fetch({
      url: `/order/${orderId}/status`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        setStatusCode(res.data.data[res.data.data.length - 1].statusCode)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      // setIsLoading(false)
    })
  }

  useEffect(() => {
    getFileUrl()
    getOrderStatus()
  }, [fileType])

  const props = {
    name: 'attachment',
    action: `${endpoint}/order/${orderId}/header/upload/${fileType}`,
    headers: { Authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`) },
    accept: 'application/pdf',
    defaultFileList: fileList,
    multiple: false,
    showUploadList: false,

    onChange(info) {
      setIsLoading(true)
      setFileList([])
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded suuccessfully`)
        getFileUrl()
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        getFileUrl()
      }
    },
  }

  const downloadFile = () => {
    setIsLoading(true)
    if (fileList[0]?.orderFileId) {
      fetchDownload({
        url: `/order/${orderId}/header/download/${fileList[0]?.orderFileId}`,
        fileName: `${fileType == 'warranty' ? 'warranty' : 'terms_of_service'}_${orderId}_${format(new Date(), 'dd-MM-yyyy')}.pdf`,
      }).then((res) => {
        if (res.success) {
          message.success('Download Success')
        } else {
          message.error(res?.message)
        }
      })
    } else {
      message.error('Please Upload Quotation!')
    }
    setIsLoading(false)
  }

  return (
    <>
      <Spin spinning={isLoading}>
        <Space>
          {(['DRF', 'SOC', 'PRC'].includes(statusCode))
            && (
              <>
                <Tooltip title="Upload File">
                  <Upload {...props} maxCount={1}>
                    <Row type="flex" justify="center" align="middle">
                      <Button
                        icon={<UploadOutlined />}
                        shape="circle"
                      />
                    </Row>
                  </Upload>
                </Tooltip>
                <Divider type="vertical" orientation="center" />
              </>
            )}
          {fileList.length > 0 ? (
            <a
              onClick={() => { downloadFile() }}
            >
              {/* {fileList[0]?.name} */}
              {fileType == 'warranty' ? 'warranty.pdf' : 'terms.pdf'}
            </a>
          ) : 'No File'}

        </Space>
      </Spin>
    </>
  )
}

export default FileUpload

